import jQuery from 'jquery';
import { flatMap } from '../../helpers/utils';

const PRICE_ELEMENT_SELECTOR = '.js-diffusionPriceValueOddsTab';
const HORSE_ELEMENT_SELECTOR = '.RC-oddsRunnerContent__runnerRow';
const HORSE_NAME_PROPERTY_NAME = 'data-diffusion-horsename';
const BOOKMAKER_PROPERTY_NAME = 'data-diffusion-bookmaker';
const ORDER_NO_PROPERTY_NAME = 'data-order-no';

function filterByObject(filter) {
    const keys = Object.keys(filter);
    return filtered => keys.every(key => filter[key] === filtered[key]);
}

export default class HorsesRowsStore {
    constructor(pageConfig) {
        this.pageConfig = pageConfig;
    }

    init() {
        this.horsesRowElements = jQuery(HORSE_ELEMENT_SELECTOR)
            .toArray()
            .map((horseRowElement) => {
                const horseName = horseRowElement.getAttribute(HORSE_NAME_PROPERTY_NAME);
                const orderNo = horseRowElement.getAttribute(ORDER_NO_PROPERTY_NAME);
                const prices = jQuery(`[${BOOKMAKER_PROPERTY_NAME}]`, horseRowElement)
                    .toArray()
                    .map(bookmakerPriceContainer => ({
                        ...this.pageConfig,
                        horseName,
                        bookmaker: jQuery(bookmakerPriceContainer).attr(BOOKMAKER_PROPERTY_NAME),
                        priceElement: jQuery(bookmakerPriceContainer)
                            .find(PRICE_ELEMENT_SELECTOR)[0]
                    }));
                return {
                    horseName,
                    orderNo,
                    horseRowElement,
                    prices
                };
            });
    }

    getPrices(selector) {
        let filterItems = this.horsesRowElements;
        if (selector) {
            if (selector.horseName) {
                filterItems = this.getHorses([selector.horseName]);
            }
            const selectFunction = filterByObject(selector);
            return flatMap(({ prices }) => prices.filter(selectFunction))(filterItems);
        }
        return flatMap(({ prices }) => prices)(filterItems);
    }

    getHorses(horseNames) {
        return (!horseNames)
            ? this.horsesRowElements
            : this.horsesRowElements
                .filter(this.isPropertyInValues(horseNames, 'horseName'));
    }

    updatePrice(selector, newValues) {
        this.getPrices(selector)
            .forEach((price) => {
                Object.assign(price, newValues);
            });
    }

    updateHorse(horseName, newValues) {
        this.getHorses([horseName])
            .forEach((horse) => {
                Object.assign(horse, newValues);
            });
    }

    /**
     * @private
     */
    isPropertyInValues(items, propName) {
        return ({ [propName]: value }) => items.includes(value);
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/oddsTabHandler/HorsesRowsStore.js